var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWheelchair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_524_9058)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3985 18.7443C17.3587 18.8017 17.3225 18.8625 17.2904 18.9268C16.9775 19.5525 17.1532 20.2948 17.6729 20.7199C14.7552 20.5124 11.7754 21.6042 9.66651 23.9464L9.09674 23.4334L9.66651 23.9464C6.03512 27.9794 6.36074 34.1927 10.3938 37.824L9.78068 38.505L10.3938 37.824C14.4269 41.4554 20.6401 41.1298 24.2715 37.0967C26.1586 35.001 26.9771 32.3164 26.762 29.7113C26.9591 29.8096 27.1814 29.8649 27.4165 29.8649C27.9501 29.8649 28.4172 29.5804 28.6744 29.1548C29.0522 32.401 28.0855 35.7876 25.7268 38.4071C21.3717 43.244 13.9203 43.6345 9.08343 39.2794C4.24659 34.9244 3.85609 27.4728 8.21119 22.636C10.6406 19.9379 14.0334 18.6234 17.3985 18.7443Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7466 16.6805V26.4808C17.7466 26.5856 17.7517 26.6901 17.7619 26.7944C17.7722 26.8988 17.7876 27.0023 17.8081 27.1052C17.8285 27.208 17.8539 27.3096 17.8844 27.4099C17.9148 27.5102 17.9501 27.6088 17.9902 27.7056C18.0303 27.8025 18.0751 27.8972 18.1245 27.9896C18.174 28.0821 18.2278 28.1719 18.286 28.2591C18.3443 28.3462 18.4066 28.4303 18.4731 28.5113C18.5396 28.5924 18.6099 28.67 18.684 28.7441C18.7582 28.8182 18.8358 28.8885 18.9168 28.955C18.9978 29.0216 19.0819 29.0839 19.1691 29.1422C19.2563 29.2004 19.3461 29.2543 19.4385 29.3037C19.531 29.3531 19.6256 29.3978 19.7225 29.4379C19.8193 29.478 19.9179 29.5133 20.0182 29.5438C20.1186 29.5742 20.2201 29.5996 20.323 29.6201C20.4258 29.6405 20.5294 29.6559 20.6337 29.6662C20.738 29.6765 20.8426 29.6816 20.9474 29.6816H30.7426C30.8845 29.6816 31.026 29.6892 31.1671 29.7042C31.3082 29.7193 31.4481 29.7417 31.5868 29.7717C31.7255 29.8016 31.8622 29.8388 31.997 29.8833C32.1317 29.9278 32.2637 29.9793 32.393 30.0378C32.5222 30.0964 32.648 30.1616 32.7704 30.2334C32.8927 30.3054 33.0108 30.3836 33.1248 30.468C33.2389 30.5525 33.3481 30.6428 33.4524 30.7389C33.5569 30.835 33.6559 30.9364 33.7495 31.043L41.519 39.8926",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1055 9.8769C15.1055 8.32969 16.3597 7.07544 17.9069 7.07544C19.4541 7.07544 20.7084 8.32969 20.7084 9.8769C20.7084 11.4241 19.4541 12.6784 17.9069 12.6784C16.3597 12.6784 15.1055 11.4241 15.1055 9.8769Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.604 23.5H24.479",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_524_9058"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.7196,
    height: 41.6154,
    fill: "white",
    transform: "translate(0 5.875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelchair);
export default __webpack_public_path__ + "static/media/wheelchair.a588e47abcd0fba45acfa1719d1eef62.svg";
export { ForwardRef as ReactComponent };